import type { ReactNode, ReactElement } from 'react';
import { isValidElement, cloneElement } from 'react';
import isEmpty from 'lodash/isEmpty';

import { isValidValue } from '../conditional-display/helpers';

export const arrayChunks = <T>(array: T[], chunkSize = 1) =>
    Array(Math.ceil(array.length / chunkSize))
        .fill(null)
        .map((_, index) => index * chunkSize)
        .map(begin => array.slice(begin, begin + chunkSize));

export const withPrepend = (prepend: unknown, elements: JSX.Element[]) => {
    if (!prepend) {
        return elements;
    }
    if (Array.isArray(prepend)) {
        return prepend.concat(elements);
    }

    return [prepend].concat(elements);
};

type TGetAppendSlotProps = {
    append: ReactNode;
    conditions?: {
        maxLength?: number;
        minLength?: number;
    };
    length: number;
};
export const getAppendSlot = ({ append, conditions, length }: TGetAppendSlotProps) => {
    if (!isEmpty(conditions)) {
        return isValidValue({
            minValue: conditions?.minLength,
            maxValue: conditions?.maxLength,
            value: length,
        })
            ? append
            : undefined;
    }

    return append;
};

/**
 * Wrapper может содержать несколько уровней дочерних компонентов. Нужно заменять на самом нижнем уровне
 * Например: <WrapperComponent><NamedContainer="content"><TextHolder text=""></NamedContainer></WrapperComponent>
 * TextHolder будет заменен на elements
 * */
export function replaceDeepLastChildren(elements: ReactElement[], children?: ReactNode): ReactNode {
    if (!isValidElement(children) || !children?.props?.children) {
        return elements;
    }

    return cloneElement(children as JSX.Element, {
        children: replaceDeepLastChildren(elements, children?.props?.children),
    });
}
